import { newMessageHandler } from "./new-message-handler";
import { updateMessageFileHandler } from "./update-message-file-handler";
import { showTypingNotificationHandler } from "./show-typing-notification";
import { updateMessageStatusesHandler } from "./update-message-statuses-handler";
import { setOperatorNameHandler } from "./set-operator-name";
import { showNotificationHandler } from "./show-notification-handler";

const eventHandlers = {
  newMessage: newMessageHandler,
  updateFileMessage: updateMessageFileHandler,
  updateMessageStatuses: updateMessageStatusesHandler,
  showTypingNotification: showTypingNotificationHandler,
  setOperatorName: setOperatorNameHandler,
  showNotification: showNotificationHandler,
};

export { eventHandlers };
